import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { DeliveryProvider } from "@/contexts/delivery.context";
import { AuthProvider } from "@/contexts/auth.context";
import { Navigator } from "@/components/navigator";
import { TOKEN_STORAGE_KEY, USER_STORAGE_KEY } from "@/config/base";
import { TOUR_STEPS } from "@/config/tour-steps";
import { shouldShowTour } from "@/contexts/tour.context";
import { lazy, Suspense, useEffect, useState } from "react";

const ProductTour = lazy(() =>
  import("@/components/tour/product-tour").then((module) => ({
    default: module.ProductTour,
  }))
);
const OnboardJSTourAdapter = lazy(() =>
  import("@/components/tour/adapters/onboardjs").then((module) => ({
    default: module.OnboardJSTourAdapter,
  }))
);

export const Route = createFileRoute("/app")({
  beforeLoad: () => {
    const token = localStorage.getItem(TOKEN_STORAGE_KEY);
    const userStr = localStorage.getItem(USER_STORAGE_KEY);

    if (!token || !userStr) {
      throw redirect({
        to: "/auth/identify",
      });
    }

    try {
      const user = JSON.parse(userStr);
      if (!user.telefoneVerificado) {
        throw redirect({
          to: "/auth/verify-phone",
          search: { telefone: user.telefone },
        });
      }
    } catch (error) {
      if (error instanceof redirect) {
        throw error;
      }
      throw redirect({
        to: "/auth/identify",
      });
    }
  },
  component: RootLayout,
});

function RootLayout() {
  const [tourEnabled, setTourEnabled] = useState(false);

  useEffect(() => {
    setTourEnabled(shouldShowTour());
  }, []);

  return (
    <DeliveryProvider>
      <AuthProvider>
        <section>
          <Outlet />
        </section>
        <Navigator />
        {tourEnabled && (
          <Suspense fallback={null}>
            <OnboardJSTourAdapter steps={TOUR_STEPS}>
              <ProductTour />
            </OnboardJSTourAdapter>
          </Suspense>
        )}
      </AuthProvider>
    </DeliveryProvider>
  );
}
